import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { I18nProvider } from './i18n/I18nContext';

ReactDOM.render((
  <BrowserRouter>
    <ScrollToTop>
      <I18nProvider>
        <App />
      </I18nProvider>
    </ScrollToTop>
  </BrowserRouter>
), document.getElementById('root')
);
registerServiceWorker();
